import React, { PureComponent, Component } from "react";
import { requestUnporcessedNewsDataForModeration, postProcessedNewsDataToServer } from './action';
import { connect } from 'react-redux';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Modal from "../../../../components/UI/Modal/Modal"; 
import { Preloading } from '../../../../components/UI/Preloader/action';
import { getCrawlerStatus } from '../../CommonComponent/action'; 
import {  Table, ModalHeader, ModalBody, ModalFooter, Row, Col, Button } from 'reactstrap';
import ViewNewsCases from "./TableView";
import { toast, ToastContainer} from 'react-toastify';
import _ from "lodash";

const CLOSE = "CLOSE";
const SUBMIT = "SUBMIT";
const CANCEL = "CANCEL";
const PROCEED = "PROCEED";
const SUBMITDATE = "SUBMITDATE";
class NewsModeration extends Component {

    state = { newsArticles: {}, confirmModal: false, modalMessage: "", type: "", modalheader: "", resizeZIndex : false, selectAll: false}

    
    handleOnChange = (type, value, index) => {
        let newsArticles = this.state.newsArticles;
        let obj = this.state.newsArticles[index];
        let invalidCaseCount = this.state.invalidCaseCount;
        if (type === "checkbox") {
            if(value){
                obj = {...obj, newsInvalid : true};
                invalidCaseCount = invalidCaseCount + 1;
            }else{
                obj = {...obj, newsInvalid : false}
                invalidCaseCount =invalidCaseCount - 1 ;
            }
        } else if (type === "sentiment") {
            obj = {...obj, newsSentiment : value};
        }
        newsArticles[index] = obj;
        this.setState({ newsArticles : newsArticles, invalidCaseCount : invalidCaseCount })
    }

    handelSelectAllChange = () => {
        var selectAll = !this.state.selectAll;
        let invalidCaseCount = this.state.invalidCaseCount;
        Object.values(this.state.newsArticles).map((x, index) => {
            x.newsInvalid = selectAll;
            if (selectAll){
                invalidCaseCount++;
            } else{
                invalidCaseCount--;
            }
        });
        this.setState({ selectAll: selectAll, invalidCaseCount: invalidCaseCount});
    }

    handleConfirmModalButton = (type) => {
        if (type === PROCEED) {
            if (this.state.type === CLOSE) {
                this.props.moderateNews();
            } else if (this.state.type == SUBMIT){
                this.props.postProcessedNewsDataToServer( { data : {...this.props.newsUnprocessedData, newsArticles : Object.values(this.state.newsArticles), corporateId : this.props.corporateId} });
                this.props.Preloading(true);
                this.setState({resizeZIndex : true})
            }
            else{
                this.props.moderateNews();
            }
        }
        this.setState({ confirmModal : !this.state.confirmModal });
    }

    handleButton = ( type ) =>{
        let modalMessage = "";
        let modalheader = "";
        if(type === CLOSE){
            modalMessage = " Are you sure you wish to close ?";
            modalheader = " Close Moderation Screen ?";
        }else{
            modalheader = "Updating News Articles";
            modalMessage = ` Are you sure you wish to update ${this.state.invalidCaseCount} News Articles ?`;
        }
        this.setState({ confirmModal: !this.state.confirmModal, type: type, modalMessage: modalMessage,  modalheader: modalheader });
    }

    componentDidMount() {
        if(this.props.newsUnprocessedData && this.props.newsUnprocessedData.newsDetails.length > 0){
            let invalidCaseCount = 0;
            this.setState({ newsArticles: this.props.newsUnprocessedData.newsDetails, initialInvalidCaseCount : invalidCaseCount,  
                invalidCaseCount : invalidCaseCount})
        }
    }

    componentDidUpdate(prevProps){
        if(this.props.newsProcessedData != prevProps.newsProcessedData ){
            this.props.Preloading(false);
            if(this.props.newsProcessedData.response == "Success"){
                toast.success(
                    <div>
                        <i className="fa fa-check"></i> {`News Moderation request placed Successfully !`}
                    </div>
                );
                this.props.getCrawlerStatus([{counterpartyId: this.props.newsUnprocessedData.counterpartyId, corporateId: this.props.corporateId}]);
                this.props.requestUnporcessedNewsDataForModeration(this.props.newsUnprocessedData.counterpartyId);
                this.props.moderateNews();
                
            }else{
                toast.error(
                    <div>
                        <i className="fa fa-warning"></i>Something went wrong, Please try again !
                    </div>
                );
            }
            this.setState({resizeZIndex : false })
        }
    }


    render() {
        return (<React.Fragment>
            <Modal show={this.props.open} className={ ( this.state.resizeZIndex  || this.state.confirmModal) ? "z-index-zero legal-modal Large-Modal" : " legal-modal Large-Modal" } >
                <ModalHeader className ="justify-content-center">
                    News Moderation -  {this.props.name}
                </ModalHeader>
                <ModalBody>
                    <ViewNewsCases
                        tasks={Object.values(this.state.newsArticles)}
                        handleOnChange={this.handleOnChange}
                        handleSelectAllChange={this.handelSelectAllChange}
                        selectAll={this.state.selectAll}/>
                </ModalBody>
                <ModalFooter>
                    <Row>
                        <Col ><Button color="info" size="lg"  className="justify-content-center" onClick={() => this.handleButton(CLOSE)} > Close </Button></Col>
                        <Col><Button color="danger"  size="lg"  className="justify-content-center" onClick ={()=> this.handleButton(SUBMIT)}>Update Articles </Button></Col>
                    </Row>

                </ModalFooter>
            </Modal>
            <Modal show={this.state.confirmModal} className="legal-confirm-modal Large-Modal" >
                <ModalHeader>
                    {this.state.modalheader}
                </ModalHeader>
                <ModalBody>
                    {this.state.modalMessage}
                </ModalBody>
                <ModalFooter>
                    <Col ><Button color="info" size="lg" className="justify-content-center" onClick={() => this.handleConfirmModalButton (CANCEL)} > Cancel </Button></Col>
                    <Col><Button color="danger" size="lg" className="justify-content-center" onClick={() => this.handleConfirmModalButton(PROCEED)}> Proceed </Button></Col>
                </ModalFooter>
            </Modal>
        </React.Fragment>)
    }
}


const mapStateToProps = (state) =>({ newsUnprocessedData : state.newsModeration.newsUnprocessedData, newsProcessedData : state.newsModeration.newsProcessedData });

const mapDispatchToProps = dispatch => ({
    requestUnporcessedNewsDataForModeration : (data) => { dispatch(requestUnporcessedNewsDataForModeration(data)) },
    postProcessedNewsDataToServer : (data) => { dispatch(postProcessedNewsDataToServer(data))},
    Preloading : (data) => { dispatch(Preloading(data)) },
    getCrawlerStatus : (data) => { dispatch(getCrawlerStatus(data))}
});

export default connect(mapStateToProps, mapDispatchToProps)(NewsModeration);
